function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import FormElementPrimitive from "./FormElementPrimitive";
import formElementStyle from "./formElementStyle";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import merge from "lodash/merge";
var _Component;
var FormElement = function(_superClass) {
    "use strict";
    _inherits(FormElement, _superClass);
    var _super = _createSuper(FormElement);
    function FormElement() {
        _classCallCheck(this, FormElement);
        var _this;
        _this = _super.apply(this, arguments);
        _this.addPropsToChildren = function() {
            var _props = _this.props, children = _props.children, passPropsToChildren = _props.passPropsToChildren;
            if (passPropsToChildren) {
                return React.Children.map(children, function(child) {
                    if (React.isValidElement(child)) {
                        return child !== null && React.cloneElement(child, passPropsToChildren);
                    }
                    return child;
                });
            }
            return children;
        };
        _this.mergeOrReplaceStyleObject = function() {
            var userStyle = _this.props.style;
            if (typeof userStyle === 'function') {
                return userStyle(FormElement.defaultStyle);
            }
            return merge(FormElement.defaultStyle, userStyle);
        };
        return _this;
    }
    var _proto = FormElement.prototype;
    _proto.render = function render() {
        var _props = this.props, _children = _props.children, _passPropsToChildren = _props.passPropsToChildren, isRtl = _props.isRtl, restProps = _objectWithoutProperties(_props, [
            "children",
            "passPropsToChildren",
            "isRtl"
        ]);
        return _jsx(FormElementPrimitive, _objectSpread({}, restProps, {
            style: buildFinalStyle(this.mergeOrReplaceStyleObject(), isRtl),
            children: this.addPropsToChildren()
        }));
    };
    _createClass(FormElement, null, [
        {
            key: "defaultStyle",
            get: function get() {
                return cloneDeep(this._defaultStyle);
            }
        }
    ]);
    return FormElement;
}(_Component = React.Component);
FormElement._defaultStyle = formElementStyle;
FormElement.defaultProps = {
    isRtl: false
};
export { FormElement as default };
function buildFinalStyle(styleObject, isRtl) {
    return _objectSpread({}, get(styleObject, 'default', {}), get(styleObject, "textDirection.".concat(isRtl ? 'rtl' : 'ltr')));
}
